<script>
  export let id;
  export let title;
  export let open = false;
  export let disabled = false;
  export let onToggle = () => {};
</script>

<section class="inventory-accordion-item" class:is-open={open}>
  <h3 class="inventory-accordion-heading" id={`inventory-heading-${id}`}>
    <button type="button" class="inventory-accordion-button" class:collapsed={!open} {disabled}
      aria-expanded={open} aria-controls={`inventory-panel-${id}`} on:click={onToggle}>
      <svg class="accordion-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
        {#if id === 'stock'}<path d="M7 20V4m-4 4 4-4 4 4M17 4v16m-4-4 4 4 4-4" />
        {:else if id === 'kardex'}<path d="M5 3h14v18H5zM9 3v18M12 8h4M12 12h4M12 16h4M3 7h4M3 12h4M3 17h4" />
        {:else if id === 'editor'}<path d="m4 16 11-11 4 4L8 20H4zm10-10 4 4M3 22h18" />
        {:else if id === 'equivalences'}<path d="m10 8 3-3a4 4 0 0 1 6 6l-3 3m-2 2-3 3a4 4 0 0 1-6-6l3-3m0 6 8-8" />
        {:else if id === 'labels'}<path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h3v3h-3zM21 14v4h-3v3h-4m7 0h-1" />
        {:else if id === 'logs'}<path d="M4 3h16v18H4zM8 8h8M8 12h8M8 16h5" />
        {:else}<path d="M9 6h11M9 12h11M9 18h11M3 6l1 1 2-2M3 12l1 1 2-2M3 18l1 1 2-2" />{/if}
      </svg>
      <span>{title}</span>
      <svg class="accordion-chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m3 6 5 5 5-5" /></svg>
    </button>
  </h3>
  <div class="inventory-accordion-body" id={`inventory-panel-${id}`} role="region" aria-labelledby={`inventory-heading-${id}`} hidden={!open}>
    <slot />
  </div>
</section>
